import { useTranslation } from 'react-i18next';
import { add, format } from 'date-fns';
import { Link, ThemeProvider, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { dateFnsLocale } from '@tools/dateFnsLocale';
import { theme } from '../../configs/theme';
import Logo from './img/Logo-Ujin.svg';
import { getAndCheckDatesFrom, MOSKOW_OFFSET } from './resolveDates';
import * as Styled from './styled';

export const TechnicalWork = ({ datesString }: { datesString?: string }) => {
  const { t } = useTranslation();

  if (!datesString) return null;

  const { end } = getAndCheckDatesFrom(datesString);

  const clientOffset = new Date().getTimezoneOffset();
  const offset = MOSKOW_OFFSET - clientOffset;

  const endWithOffset = add(end, { minutes: offset });
  const endString = format(endWithOffset, t('DayMonthTimeFormat'), {
    locale: dateFnsLocale,
  });

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={dateFnsLocale}>
        <Styled.Page>
          <Styled.Wrapper>
            <Styled.Header>
              <Logo />
            </Styled.Header>

            <Styled.Body>
              <Typography variant="h4">{t('SiteUnderMaintenance')}</Typography>
              <Typography variant="h5">
                {t('ServiceWillBeRestored')} <br />
                {endString}
              </Typography>
            </Styled.Body>

            <Styled.Footer>
              <Typography variant="body1">{`${t('WeAreInTouch')}:`}</Typography>

              <Styled.Contacts>
                <Link href="tel:+74951082450">+7 495 108-24-50</Link>

                <Link href="mailto:info@ujin.tech">info@ujin.tech</Link>
              </Styled.Contacts>
            </Styled.Footer>
          </Styled.Wrapper>
        </Styled.Page>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export * from './resolveDates';
